import React, {useState, useEffect} from 'react';

import UpdateMember from '../components/Form/UpdateMember';
import UpdateParticipant from '../components/Form/UpdateParticipant';
import ChangeUserPasswordAndDeleteAccount from '../components/Form/ChangeUserPasswordAndDeleteAccount';
import {EmptyText, ErrorAlert, Spinner} from '../utils/commonStyledComponents';
import {fetchCities, fetchMemberRelationships} from '../utils/api';

// Rebranding 2026 · Account allineato al prototipo account-ivory.html
// Layout: aside (credenziali + delete) a SX · main (titolare + partecipanti) a DX
const Account = () => {
  const [loading, setLoading] = useState(true);
  const [participants, setParticipants] = useState([]);
  const [cities, setCities] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [relations, cities] = await Promise.all([
          fetchMemberRelationships(),
          fetchCities(),
        ]);

        setParticipants(relations);
        setCities(cities);
        setLoading(false);
      } catch (e) {
        setShowErrorMessage(true);
      }
    })();
  }, []);

  if (showErrorMessage) {
    return <ErrorAlert>Si è verificato un errore di caricamento</ErrorAlert>;
  }

  if (loading) {
    return <Spinner />;
  }

  return (
    <main className="gc-wrap gc-wrap--page">
      <div className="gc-sc-account">
        <aside className="gc-sc-account__aside">
          <ChangeUserPasswordAndDeleteAccount />
        </aside>

        <div className="gc-sc-account__main">
          <UpdateMember cities={cities} />
          {renderParticipants(participants, cities)}
        </div>
      </div>
    </main>
  );
};

const renderParticipants = (participants, cities) => {
  if (!participants.length) {
    return <EmptyText></EmptyText>;
  }

  return participants.map((relation, index) => (
    <UpdateParticipant
      key={index}
      participant={relation.member}
      id={relation.id}
      type={relation.type}
      cities={cities}
    />
  ));
};

export default Account;
